import { useSelector } from "react-redux";

// Constants  and Utils
import { constructRadarChartData } from "../../../utils/ChartUtils";
import { getMediaLtsRating, getMediaOts } from "../../../utils/mavinMetrics";

// Components
import { RadarChart } from "../../../components/charts/Charts";
import MediaInfo from "../../../mavin/components/media-info/MediaInfo";
import {
  ArAC_ratings,
  CityPopulation,
  MediaFrequency,
  MediaReach,
  MediaTgFrequency,
  MonthlyImpressions,
  OtherDetails,
} from "../../../mavin/components/media-site-performance/SitePerformanceUtils";

// Section Functions
function constructMediaObject(mediaInfoBean) {
  const media = {
    title: "",
    type: "",
    height: "",
    width: "",
    litStatus: "",
  };

  if (Object.keys(mediaInfoBean).length === 0) {
    return media;
  }

  media.title = mediaInfoBean.title;
  media.type = mediaInfoBean.type;
  media.height = mediaInfoBean.height;
  media.width = mediaInfoBean.width;
  media.litStatus = mediaInfoBean.lit;

  return media;
}

function SitePerformanceSection({ mavinMetrics, regionInfo }) {
  const {
    otsSummary,
    ltsSummary,
    dwellTimeSummary,
    reachFrequency = {},
    query,
  } = mavinMetrics;

  // LIT STATUS
  const { lit: litStatus } = query;

  // OTS
  const { durationDays } = otsSummary || {};
  const { ots, tgOts } = getMediaOts({ ...mavinMetrics, litStatus }) || {};

  // LTS
  const ltsRating = getMediaLtsRating(ltsSummary);
  const { population } = regionInfo || {};

  return (
    <div className="row">
      {/* Impressions, Reach, Population, Frequency, Lts rating, ArAC Rating*/}
      <MonthlyImpressions
        impressions={{ ots, tgOts }}
        duration={durationDays}
        targetGroupId={query.targetGroupId}
      />
      <CityPopulation cityPopulation={population} />
      <MediaReach
        reachFrequency={reachFrequency}
        cityPopulation={population}
        targetGroupId={query.targetGroupId}
      />
      <MediaFrequency reachFrequency={reachFrequency} />
      <MediaTgFrequency
        reachFrequency={reachFrequency}
        targetGroupId={query.targetGroupId}
      />
      <OtherDetails
        ltsRating={ltsRating}
        reachFrequency={reachFrequency}
        dwellTimeSummary={dwellTimeSummary}
      />
      <ArAC_ratings ltsSummary={ltsSummary} />
    </div>
  );
}

// Site Info and Performance Section
function MediaInfoAndPerformanceSection({ mavinMetrics, regionInfo }) {
  // Selector
  const mediaInfoBean = useSelector(
    (state) => state.singleSiteAnalyserTool.mediaInfoBean
  );

  if (Object.keys(mavinMetrics).length === 0) {
    return null;
  }

  // Lts Summary
  const ltsSummary = mavinMetrics.ltsSummary || {};

  // Constructing MediaObject for MediaInfo component
  const media = constructMediaObject(mediaInfoBean);

  // Chart data
  const chartData = constructRadarChartData(ltsSummary, regionInfo);

  return (
    <>
      <p className="h2 py-3 font-weight-bold">{"Site Report"}</p>
      <div className="d-flex">
        <div className="col-9 px-0">
          <MediaInfo media={media} titleClassName={"h2"} />
          <hr className="divider"></hr>
          {/* Site performance */}
          <SitePerformanceSection
            mavinMetrics={mavinMetrics}
            regionInfo={regionInfo}
          />
        </div>
        <div className="col-3 px-0">
          <RadarChart data={chartData} height={300} />
        </div>
      </div>
      <hr className="divider"></hr>
    </>
  );
}

export default MediaInfoAndPerformanceSection;
